exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo {\n  position: absolute;\n  transform: scale(1);\n  transition: transform .5s;\n  /* z-index: 99; */\n}\n\n.photo:hover {\n  transform: scale(8);\n}", ""]);

// exports
